import { Button, Collapse, Grid, IconButton } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteAddress,
  listUserAddresses,
} from '../../../actions/addressActions'
import { updateUserInfo } from '../../../actions/userActions'
import {
  ADDRESS_CREATE_RESET,
  ADDRESS_DELETE_RESET,
  ADDRESS_UPDATE_RESET,
} from '../../../constants/addressConstants'
import statesList from '../../../data/states'
import { useInput } from '../../../hooks/useInput'
import AddEditAddress from '../../Address/AddEditAddress'
import AddressBookTable from '../../Address/AddressBookTable'
import AutoCompleteSelect from '../../Form/AutoCompleteSelect'
import FormContainer from '../../Form/FormContainer'
import TextInput from '../../Form/TextInput'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ToastMessage from '../../ToastMessage/ToastMessage'

const CompanyInfo = () => {
  const dispatch = useDispatch()

  const { userInfo } = useSelector((state) => state.userLogin)
  const { success: addressUpdateSuccess } = useSelector(
    (state) => state.addressUpdate
  )
  const { success: addressCreateSuccess } = useSelector(
    (state) => state.addressCreate
  )
  const { loading: loadingDelete, success: successDelete } = useSelector(
    (state) => state.addressDelete
  )

  const [showAddressModal, setShowAddressModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState({})
  const [addressesSet, setAddressesSet] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [addressId, setAddressId] = useState(false)
  const [createAddressToast, setCreateAddressToast] = useState(false)
  const [updateAddressToast, setUpdateAddressToast] = useState(false)
  const [deleteAddressToast, setDeleteAddressToast] = useState(false)

  const {
    value: companyName,
    bind: bindCompanyName,
    error: companyNameError,
  } = useInput(userInfo.companyName)
  const {
    value: streetAddress,
    bind: bindStreetAddress,
    error: streetAddressError,
  } = useInput(
    userInfo.company &&
      userInfo.company.streetAddress &&
      userInfo.company.streetAddress
  )
  const { value: aptSuiteOther, bind: bindAptSuiteOther } = useInput(
    userInfo.company &&
      userInfo.company.aptSuiteOther &&
      userInfo.company.aptSuiteOther
  )
  const {
    value: zipCode,
    bind: bindZipCode,
    error: zipCodeError,
  } = useInput(
    userInfo.company && userInfo.company.zipCode && userInfo.company.zipCode
  )
  const {
    value: city,
    bind: bindCity,
    error: cityError,
  } = useInput(
    userInfo.company && userInfo.company.city && userInfo.company.city
  )
  const {
    value: state,
    setValue: setState,
    error: stateError,
  } = useInput(
    userInfo.company && userInfo.company.state && userInfo.company.state
  )

  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (!addressesSet) {
      setAddressesSet(true)
      dispatch(listUserAddresses(userInfo._id))
    }

    if (addressCreateSuccess) {
      dispatch({ type: ADDRESS_CREATE_RESET })
      dispatch(listUserAddresses(userInfo._id))
      setShowAddressModal(false)
      setCreateAddressToast(true)
    }

    if (addressUpdateSuccess) {
      dispatch({ type: ADDRESS_UPDATE_RESET })
      dispatch(listUserAddresses(userInfo._id))
      setShowAddressModal(false)
      setUpdateAddressToast(true)
    }

    if (successDelete) {
      setSelectedAddress({})
      dispatch({ type: ADDRESS_DELETE_RESET })
      dispatch(listUserAddresses(userInfo._id))
      setShowDeleteModal(false)
      setDeleteAddressToast(true)
    }
  }, [
    addressCreateSuccess,
    addressUpdateSuccess,
    addressesSet,
    successDelete,
    dispatch,
    userInfo,
  ])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const handleDeleteClose = () => {
    setSelectedAddress({})
    setShowDeleteModal(false)
  }

  const deleteHandler = (id) => {
    dispatch(deleteAddress(id))
  }

  const handleUpdate = () => {
    const user = {
      ...userInfo,
      companyName,
      company: {
        companyName,
        streetAddress,
        aptSuiteOther,
        city,
        state,
        zipCode,
      },
    }

    dispatch(updateUserInfo(user))
  }

  return (
    <div className="p-t-40 p-b-40" style={{ borderBottom: '1px solid black' }}>
      <div className="flex space-between">
        <div className="flex">
          <div>
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              className={`m-r-10 ${expanded ? 'rotate' : ''}`}
            >
              <ChevronRight />
            </IconButton>
          </div>
          <div>
            <h4 className="m-b-0">Company information</h4>
            <p className="m-b-0 gray-text fs14">
              Update company information, shipping addresses, and billing
              information.
            </p>
          </div>
        </div>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit className="m-l-44">
        <h5 className="fs18 m-t-32 m-b-24">Basic information</h5>

        <Grid container spacing={4} className="m-b-60">
          <Grid item xs={12} sm={6} className="p-b-0">
            <TextInput
              name="companyName"
              label="Company name"
              bindValue={bindCompanyName}
              error={companyNameError}
            />
          </Grid>
          <Grid item xs={12} sm={6} className="p-b-0"></Grid>
          <Grid item xs={12} sm={6} className="p-b-0">
            <TextInput
              name="streetAddress"
              label="Street address"
              bindValue={bindStreetAddress}
              error={streetAddressError}
            />
          </Grid>
          <Grid item xs={12} sm={6} className="p-b-0">
            <TextInput
              name="aptSuiteOther"
              label="Apt/Suite/Other"
              bindValue={bindAptSuiteOther}
            />
          </Grid>
          <Grid item xs={12} sm={6} className="p-b-0">
            <TextInput
              name="city"
              label="City"
              bindValue={bindCity}
              error={cityError}
            />
          </Grid>

          <Grid item xs={6} sm={3} className="p-b-0">
            <AutoCompleteSelect
              label="State"
              name="state"
              options={statesList}
              value={state}
              setValue={setState}
              error={stateError}
              minWidth={246}
            />
          </Grid>
          <Grid item xs={6} sm={3} className="p-b-0">
            <TextInput
              name="zipCode"
              label="Zip Code"
              bindValue={bindZipCode}
              error={zipCodeError}
            />
          </Grid>
        </Grid>

        <AddressBookTable
          setShowModal={setShowAddressModal}
          setShowDeleteModal={setShowDeleteModal}
          setSelectedAddress={setSelectedAddress}
          setAddressId={setAddressId}
          type="Shipping"
          hideCheckBoxes={true}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="flex flex-end m-t-32 m-b-50">
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
              >
                Update
              </Button>
            </div>
          </Grid>
        </Grid>
      </Collapse>

      <ModalPopUp
        title={
          Object.keys(selectedAddress).length === 0
            ? 'Add new address'
            : 'Edit address'
        }
        setShowModal={setShowAddressModal}
        showModal={showAddressModal}
      >
        <FormContainer>
          <h2 className="m-b-30">
            {Object.keys(selectedAddress).length === 0
              ? 'Add new address'
              : 'Edit address'}
          </h2>

          <AddEditAddress
            selectedAddress={selectedAddress}
            setShowForm={setShowAddressModal}
          />
        </FormContainer>
      </ModalPopUp>

      <ModalPopUp
        title="Delete address?"
        setShowModal={handleDeleteClose}
        showModal={showDeleteModal}
      >
        <h2 className="m-b-30">
          Are you sure you want to remove this address?
        </h2>

        <div>
          {selectedAddress.companyName && (
            <>
              {selectedAddress.companyName} <br />
            </>
          )}
          {selectedAddress.streetAddress}
          {selectedAddress.aptSuiteOther !== '' && ' '}
          {selectedAddress.aptSuiteOther}
          <br />
          {selectedAddress.city}, {selectedAddress.state}{' '}
          {selectedAddress.zipCode}
        </div>

        <div className="actions space-between flex m-t-40">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDeleteClose}
            disabled={loadingDelete}
            className={loadingDelete ? 'loading' : ''}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => deleteHandler(selectedAddress._id)}
            disabled={loadingDelete}
            className={loadingDelete ? 'loading' : ''}
          >
            Delete
          </Button>
        </div>
      </ModalPopUp>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Address created</p>
            <p className="fs14 m-b-0">
              You have successfully created a new address.
            </p>
          </>
        }
        open={createAddressToast}
        setOpen={setCreateAddressToast}
      />
      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Address updated</p>
            <p className="fs14 m-b-0">
              You have successfully updated the address.
            </p>
          </>
        }
        open={updateAddressToast}
        setOpen={setUpdateAddressToast}
      />
      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Address delete</p>
            <p className="fs14 m-b-0">
              You have successfully deleted the address.
            </p>
          </>
        }
        open={deleteAddressToast}
        setOpen={setDeleteAddressToast}
      />
    </div>
  )
}

export default CompanyInfo
